<template>
  <div class="theme-bg">
    <v-list-item-group
      v-model="settings"
      style="max-height: 240px; overflow-y: scroll"
    >
      <template v-for="(task, index) in tasks">
        <v-list-item :key="index">
          <v-list-item-content class="text-color">
            <v-list-item-title>{{ task.label }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list-item-group>
  </div>
</template>

<style scoped>
.theme-bg {
  background: #5351a0;
}
.text-color {
  color: #fff !important;
}
</style>

<script>
export default {
  name: "Task",
  data: () => ({
    fav: true,
    menu: false,
    message: false,
    hints: true,
    item: 1,
    speech: {},
    settings: [],
    tasks: [],
    items: [
      { text: "Real-Time", icon: "mdi-clock", nav: "dashboard" },
      { text: "Audience", icon: "mdi-account", nav: "dashboard" },
      { text: "Help", icon: "mdi-account", nav: "help" },
      { text: "Logout", icon: "mdi-flag", nav: "login" },
    ],
  }),
  methods: {
  nav(path) {
      this.$router.push({ name: path });
   },

  getPriorityColor (priority) {
    if (priority === 'High') return 'red'
    else if (priority === 'Medium') return 'yellow'
    else return 'grey'
  },
  
  getStatusColor (status) {
    if (status === 'To do') return 'blue'
    else if (status === 'Doing') return 'orange'
    else return 'success'
  },

  getFormattedDate (date) {
    return new Date(date).toJSON().slice(0,10).replace(/-/g,'/');
  },

  classifyDate(date){
    if (new Date().toJSON().slice(0,10) === date) return 'For today'
    else if (new Date().toJSON().slice(0,10) > date) return 'Overdue'
    else return 'For the future'
  },

  getDateColor (date) {
    if (this.classifyDate(date) === 'For today') return 'orange'
    else if (this.classifyDate(date) === 'Overdue') return 'red'
    else return 'success'
  },

    loadClient() {
      let self = this;
      window.gapi.client.setApiKey("AIzaSyCwSEFovFNJ9L_47CuTBIGGJ4qntTOJmrM");
      return window.gapi.client
        .load(
          "https://content.googleapis.com/discovery/v1/apis/calendar/v3/rest"
        )
        .then(
          function () {
            console.log("GAPI client loaded for API");
            // self.execute();
            self.listUpcomingEvents();
          },
          function (err) {
            console.error("Error loading GAPI client for API", err);
          }
        );
    },
    authenticate() {
      return window.gapi.auth2
        .getAuthInstance()
        .signIn({
          scope:
            "https://www.googleapis.com/auth/calendar https://www.googleapis.com/auth/calendar.readonly",
        })
        .then(
          function () {
            console.log("Sign-in successful");
            localStorage.setItem("calendar", "logged");
            localStorage.setItem("currentEvent", "events");
          },
          function (err) {
            console.error("Error signing in", err);
          }
        );
    },
    readOutLoud: (msg) => {
      const speech = new SpeechSynthesisUtterance();
      const voiceName = 'Google UK English Male';
      speech.volume = 1;
      speech.rate = 1;
      speech.pitch = 1;
      speech.voice = speechSynthesis.getVoices().filter(function (voice) {
      return voice.name === voiceName
    })[0]
      speech.text = msg;
      window.speechSynthesis.speak(speech);

     speech.onend = function() {
      setTimeout(() => {
      Event.$emit('speakModeOn');
      }, 3200);
     };
    },
    listUpcomingEvents() {
      let self = this;
      self.tasks = [];
      window.gapi.client.calendar.events
        .list({
          calendarId: "primary",
          timeMin: new Date("10/20/2019").toISOString(),
          timeMax: new Date().toISOString(),
          showDeleted: false,
          singleEvents: true,
          maxResults: 10,
          orderBy: "startTime",
        })
        .then(function (response) {
          var events = response.result.items;
          console.log("Upcoming events:");

          Event.$emit("tasks", { events: events });
          localStorage.setItem("currentEvent", "events");
          if (events.length > 0) {
            for (let i = 0; i < events.length; i++) {
              var event = events[i];
              var when = event.start.dateTime;
              if (!when) {
                when = event.start.date;
              }
              self.tasks.push({
                label: event.summary + " (" + when + ")",
                selected: true,
              });
              // console.log(event.summary + " (" + when + ")");
            }
          } else {
            console.log("No upcoming events found.");
          }
        });
    },
    readAllMessages() {},
  },
  mounted() {
    // if (localStorage.getItem("calendar") == null) {
    this.authenticate().then(this.loadClient);
    // } else {
    //   this.listUpcomingEvents();
    // }

    Event.$on("stop", () => {
      this.speech.stop();
    });

    Event.$on("read", () => {
      // for (let i = 0; i < this.tasks.length; i++) {
      this.readOutLoud(this.tasks[0].label);
      // }
    });
  },
};
</script>